module.exports = __webpack_public_path__ + "img/titleMax.b824e44e.png";